





























































import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

type OptionItem = { value: string | number; text: string };

@Component({
  name: 'bpc-display-field-tppwb-sync',
  components: {},
})
export default class DisplayFieldTppwbSync extends mixins(AbstractDisplayField) {
  discipline = this.fieldConfig.discipline ?? null;
  selectedValue: string | number = null;
  private previousValue: string | number = null;
  isSaving = false;

  mounted() {
    this.selectedValue = this.value;
    this.previousValue = this.value;
  }

  get syncStatus(): string {
    return this.discipline === 'tennis'
      ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.sync_status
      : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.sync_status;
  }

  get errorMessage(): string {
    const error =
      this.discipline === 'tennis'
        ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.error_message
        : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.error_message;

    return error ? error.replace(/^.*:\s*/, '') : '';
  }

  get matricule(): string {
    return this.discipline === 'tennis'
      ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.external_id
      : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.external_id;
  }

  get ranking(): string {
    return this.discipline === 'tennis'
      ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.ranking
      : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.ranking;
  }

  get active(): string {
    console.log(this.item?.sport_sheets);
    return this.discipline === 'tennis'
      ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.active
      : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.active;
  }

  get updatedAt(): string {
    const updatedAt =
      this.discipline === 'tennis'
        ? this.item?.sport_sheets?.filter(item => item.type === 'tennis')[0]?.updated_at
        : this.item?.sport_sheets?.filter(item => item.type === 'padel')[0]?.updated_at;

    return updatedAt ? this.$bpcHelper.formatDateTimeV2(updatedAt) : null;
  }

  get entity(): string {
    return this.fieldConfig.entity;
  }

  get options(): OptionItem[] {
    return this.fieldConfig.configOptions as OptionItem[];
  }

  onChangeTo(newValue) {
    if (!this.item?.id) return;

    // const newValue = this.selectValue;
    const oldValue = this.previousValue;

    this.isSaving = true;

    const path = `${this.$bpcApiRouteHelper.getApiPath(
      'contacts/' + this.item.id + '/' + 'tppwb' + '/' + this.discipline + '/change-sync-value',
    )}`;

    const payload: Record<string, string | number> = {};
    payload[this.fieldConfig.key] = newValue;

    this.$bpcApi.patch(path, payload).subscribe(
      (res: any) => {
        this.previousValue = newValue;

        this.$emit('saved-on-change', res);
        this.$root.$emit('saved-on-change-from-table', res);

        this.selectedValue = newValue;
      },
      (error: any) => {
        this.selectedValue = oldValue;
        this.$bpcMessage.showErrorMessage({
          text: 'global.generic.error_form_action',
        });
        this.isSaving = false;
      },
      () => {
        this.isSaving = false;
      },
    );
  }
}
